<script setup lang="ts">
import './assets/style.scss'
import { VModal, VPasswordField } from '@/shared/ui'
import { computed, type PropType, ref } from 'vue'
import { useModel } from './../model/model'
import { useTranslate } from '@/shared/lib'
import type { MeterTypesSelectType } from '@/entities/Meters'
import { useCabinetMetersSave } from '../model/api'

defineProps({
  types: {
    type: Array as PropType<MeterTypesSelectType[]>,
    default: [],
  },
  metersCount: {
    type: Number,
    required: true,
  },
})

const model = useModel()
const { trs } = useTranslate()

const { save, isPending } = useCabinetMetersSave()

/**
 * Вычисляем заголовок в зависимости от создания/обновления
 */
const title = computed(() => {
  if (model.data.id) {
    return trs('itf.meter_edit')
  } else if (model.replaceId) {
    return trs('itf.meter_replace')
  } else {
    return trs('itf.meter_add')
  }
})

/**
 * Вычисляем надпись кнопки в зависимости от создания/обновления
 */
const buttonText = computed(() => {
  if (model.data.id) {
    return trs('itf.save')
  } else if (model.replaceId) {
    return trs('itf.replace')
  } else {
    return trs('itf.add')
  }
})

const valid = ref(false)

/**
 * Функция обработчик сохранения счетчика
 */
const submitHandler = async () => {
  if (!valid.value) return

  save(model.data, model.replaceId).then(() => model.closeForm())
}
</script>

<template>
  <VModal :title v-model="model.openForm">
    <VForm v-model="valid" @submit.prevent="submitHandler" class="mt-2">
      <VSelect
        :label="$t('itf.meter_type')"
        v-model="model.data.meter_type_id"
        :items="types"
        item-value="id"
        item-title="meter_name"
      />

      <VTextField
        :label="$t('itf.serial_number')"
        v-model="model.data.serial_number"
        :rules="model.rules.serial_number"
      />

      <VTextField
        :label="$t('itf.address')"
        v-model="model.data.rs_address"
        :rules="model.rules.address(metersCount)"
      />

      <VTextField
        :label="$t('itf.tariff_count_label_full')"
        v-model="model.data.tariff_count"
        type="number"
        min="1"
        max="4"
        :rules="model.rules.tariff_count"
      />

      <VTextField
        :label="$t('itf.ktt')"
        v-model="model.data.ktt"
        type="number"
        min="1"
        max="1000"
      />

      <VCheckbox
        :label="$t('itf.is_password')"
        v-model="model.data.is_password_use"
        density="compact"
        class="ml-3"
        :hide-details="false"
      />

      <VPasswordField
        :label="$t('itf.password')"
        v-model="model.data.password"
        v-if="model.data.is_password_use"
      />

      <div class="form__btn_right">
        <VBtn type="submit" :loading="isPending">
          {{ buttonText }}
        </VBtn>

        <VBtn color="default" @click="model.closeForm">
          {{ $t('itf.cancel') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
